// Shared footer linking website policies and the enquiry form.
export function FooterStub() {
    return (
        <footer className="flex gap-16 pb-8 pt-section-gap">
            <div>
                <h2 className="font-medium text-unimo-slate">Legal</h2>
                <ul className="mt-3 space-y-2">
                    <li>
                        <a href="/privacy" className="text-unimo-site-grey-700">
                            Privacy Policy
                        </a>
                    </li>
                    <li>
                        <a href="/cookies" className="text-unimo-site-grey-700">
                            Cookie Policy
                        </a>
                    </li>
                    <li>
                        <a href="/terms" className="text-unimo-site-grey-700">
                            Terms of Service
                        </a>
                    </li>
                    <li>
                        <a href="/accessibility" className="text-unimo-site-grey-700">
                            Accessibility Statement
                        </a>
                    </li>
                </ul>
            </div>
            <div>
                <h2 className="font-medium text-unimo-slate">Get in touch</h2>
                <ul className="mt-3 space-y-2">
                    <li>
                        <a href="/contact" className="text-unimo-site-grey-700">
                            Contact us
                        </a>
                    </li>
                </ul>
            </div>
        </footer>
    )
}

export default FooterStub
